module.exports = __webpack_public_path__ + "img/new_label_en.20cc3b4b.svg";